import GroupNotification from "../../components/Group/GroupNotification/GroupNotification";
import { useParams } from "react-router-dom";
import { useAppSelector } from "../../app/hooks";
import { selectNotificationByID } from "../../features/notifications/notificationSlice";

const UpdateGroupNotification = () => {
  const { notificationid } = useParams<{
    notificationid: string;
  }>();

  const selectedNotification = useAppSelector((state) =>
    notificationid ? selectNotificationByID(state, notificationid) : null
  );
  return <GroupNotification isNew={false} selectedNotification={selectedNotification} />;
};
export default UpdateGroupNotification;
